import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { Location } from '@angular/common';
import { RewardsService } from '../loyalty-points/rewardservice/rewards.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-loyalty-points-radeem-succes',
  templateUrl: './loyalty-points-radeem-succes.component.html',
  standalone:false,
  styleUrls: ['./loyalty-points-radeem-succes.component.scss']
})
export class LoyaltyPointsRadeemSuccesComponent implements OnInit {

  /** Computed once at component construction time so the template can
   *  format a stable transaction ID for the receipt. */
  public redeemDate: Date = new Date();
  public referenceNumber: string = '';

  /** Status from API response (e.g. "Points Redeemed Sucessfully"). */
  public redemptionStatus: string = '';

  /** Revised available points after redemption from API response. */
  public revisedAvailablePoints: string = '';

  /** True when this is a Give Back redemption (RHF or ZAKAT). */
  public isGiveBack: boolean = false;

  /** Partner code (RHF, ZAKAT, GULF_AIR_FFP, ETIHAD, CASHBACK, ...). */
  public partnerCode: string = '';

  /** Category label if the catalog set one (Give Back, Travel, ...). */
  public category: string = '';

  /** Per-point rate used to compute the Value row. */
  public perPointRate: number = 0;

  constructor(private location: Location, private router:Router, public redeem: RewardsService, private cookieService: CookieService) { }

  async ngOnInit(): Promise<void> {
    // Pull the real transferReference from the API response stored in the service,
    // or fall back to a generated one if not available.
    const storedRef = this.redeem?.lastRedemptionTransferReference;
    if (storedRef) {
      this.referenceNumber = storedRef;
    } else {
      const ts = this.redeemDate.getTime().toString();
      const rnd = Math.floor(1000 + Math.random() * 9000).toString();
      this.referenceNumber = ts + rnd;
    }

    // Pull status and revised points from API response
    const result = this.redeem?.lastRedemptionResult;
    if (result) {
      this.redemptionStatus = result.status || '';
      this.revisedAvailablePoints = result.revisedAvailablePoints || '';
      this.partnerCode = result.partnerCode || '';
      this.category = result.category || '';
      this.perPointRate = Number(result.perPointRate) || 0;
    } else {
      // Fallback to pendingRedemption or cookies
      const pr: any = this.redeem?.pendingRedemption;
      if (pr) {
        this.partnerCode = pr.partnerCode || '';
        this.category = pr.category || '';
        this.perPointRate = Number(pr.perPointRate) || 0;
      } else {
        this.partnerCode = await this.cookieService.get('RedeemPartnerCode', true) || '';
        this.perPointRate = Number(await this.cookieService.get('perPointRate', true)) || 0;
        this.category = await this.cookieService.get('partnerCategory', true) || '';
      }
    }

    this.isGiveBack = this.computeIsGiveBack();
  }

  /** Returns true if this redemption should be treated as Give Back.
   *  Matches by partnerCode (RHF/ZAKAT) or by category name. */
  private computeIsGiveBack(): boolean {
    const code = (this.partnerCode || '').toUpperCase();
    if (code === 'RHF' || code === 'ZAKAT') return true;
    const cat = (this.category || '').toLowerCase();
    return cat === 'give back';
  }

  /** The value to display in the "Value" row.
   *  - For Give Back: "X donation"
   *  - For others: dynamic unit based on partner type (miles, Avios, Shukrans, BHD cashback, etc.) */
  getValueDisplay(): string {
    const pr: any = this.redeem?.lastRedemptionResult;
    const pts = Number(pr?.selectedPoint ?? 0) || 0;
    if (this.isGiveBack) {
      const bhd = Number(pr?.redemptionAmountBhd) || 0;
      const shown = bhd > 0 ? bhd.toFixed(3) : (pts / 140).toFixed(3);
      return `${shown} donation`;
    }
    if (this.perPointRate > 0) {
      const value = (pts * this.perPointRate).toFixed(3);
      return `${value} ${this.getValueUnit()}`;
    }
    return '';
  }

  /** Returns the unit label for the Value row (e.g. "miles", "Avios", "Shukrans", "BHD"). */
  getValueUnit(): string {
    const code = (this.partnerCode || '').toUpperCase();
    if (code === 'GULF_AIR_FFP' || code === 'ETIHAD') return 'miles';
    if (code === 'VERNOST_QRPRIVILEGECLUB' || code === 'QATAR') return 'Avios';
    if (code === 'SHUKRAN') return 'Shukrans';
    if (code === 'JAWAHER') return 'Jawaher Points';
    if (code === 'CASHBACK') return 'BHD';
    return '';
  }

  /** Whether the Value row should be visible. We hide it when there is
   *  no perPointRate and the partner isn't a Give Back partner. */
  hasValueRow(): boolean {
    if (this.isGiveBack) return true;
    return this.perPointRate > 0;
  }

  Dashboard(){
    //this.router.navigateByUrl('/Dashboard');
    this.router.navigateByUrl('/LoyaltyPoints')
  }


}
